import React, { useRef } from 'react';
import { Col, Container, Row } from 'react-bootstrap';
import AnimatedText from 'react-animated-text-content';
import BG from '../../assets/images/ut__bg.png';
import './utilities.css';
import {
  CaretLeftSquare,
  ChevronDoubleRight,
  Coin,
  CurrencyDollar,
  HandThumbsUp,
  Percent,
  PuzzleFill,
  Tree,
} from 'react-bootstrap-icons';
import Contest from '../contest/Contest';

const Utilities = () => {
  const breakpoints = [
    { width: 1, itemsToShow: 1, pagination: false, showArrows: false },
    { width: 850, itemsToShow: 3, pagination: false, showArrows: false },
    { width: 1150, itemsToShow: 4, itemsToScroll: 2, pagination: false },
    { width: 1450, itemsToShow: 4, pagination: false },
    { width: 1750, itemsToShow: 4, pagination: false },
  ];

  const utItems = [
    {
      icons: <CaretLeftSquare className='ut__icons' />,
      title: 'Free Travel',
      description:
        '5 people selected by members of the whitelist will win a travel completely paid by us in a natural location to show the beauty of this planet',
    },
    {
      icons: <HandThumbsUp className='ut__icons' />,
      title: 'Following Back',
      description: 'KuteeKitty will start to follow you back',
    },
    {
      icons: <Percent className='ut__icons' />,
      title: '20% Discount',
      description: '20% of the mint redistributed at who are in the whitelist',
    },
    {
      icons: <CurrencyDollar className='ut__icons' />,
      title: 'Free NFTs',
      description: 'Free nft of the next collection for the whitelist people',
    },
    {
      icons: <PuzzleFill className='ut__icons' />,
      title: 'Free Whitelist',
      description:
        'Whitelist for the next collection, for the first 100 that will be mint the project',
    },
    {
      icons: <Tree className='ut__icons' />,
      title: 'Tree Plantation ',
      description:
        'KuteeKitty will plant 10 trees for each owners (video prove)',
    },
    {
      icons: <Tree className='ut__icons' />,
      title: 'Profile Pic Advantages ',
      description:
        'The first 100 people who will put a kutee kitty as a profile picture (Instagram or Twitter) will be put on the whitelist for the next collection.',
    },
    {
      icons: <Tree className='ut__icons' />,
      title: 'Tree Plantation ',
      description:
        'An extraction will be made among those who have a kutee kitty as their photo profile, and there will be a cash prize',
    },
    {
      icons: <Tree className='ut__icons' />,
      title: 'YouTube % for Holders & Charity ',
      description:
        '50% of the earnest from YouTube channel will be redistributed to the holders (other 50% in charity)',
    },
    {
      icons: <Tree className='ut__icons' />,
      title: 'Web Earnings To chairities ',
      description:
        '50% of the earnest from the sales of the hoodies and t shirts will be redistributed to the holders ( other 50% in charity) ',
    },
    {
      icons: <Coin className='ut__icons' />,
      title: 'Online Store Earnings To chairities ',
      description:
        '20% of the earnest from the stores of things produced with innovative material will be redistributed to the holders',
    },
  ];

  return (
    <Container fluid className='nm np ut__container__main'>
      <Container className='ut__container '>
        <h1 className='ut__h1 '>
          <AnimatedText
            type='chars' // animate words or chars
            animation={{
              x: '200px',
              y: '-20px',
              scale: 1.1,
              ease: 'ease-in-out',
            }}
            animationType='throw'
            interval={0.06}
            duration={1}
            tag='p'
            className='animated-paragraph'
            includeWhiteSpaces
            threshold={0.1}
            rootMargin='20%'
          >
            UTILITIES
          </AnimatedText>
        </h1>
        <h3 className='ut__h3'>
          We will recycle abandoned plastic in the ocean and earth to produce
          beautiful and valuable physical assets NFTs.
        </h3>
        <Row>
          <Col md={6}>
            <Row className='nm'>
              <Col md={12} className='ut__box'>
                {' '}
                <h2 className='ut__h2'> Perks of Membership</h2>
                <p className='ut__p1'>
                  <span className='ut__bullet'>
                    <ChevronDoubleRight
                      style={{
                        fontSize: '20px',
                        marginRight: '10px',
                        color: '#fff',
                      }}
                    />{' '}
                    The first 100 members will be whitelisted who have their
                    profile pictures of our NFT. Whoever wins our extraction, we
                    gift them with eth!
                  </span>
                  <span className='ut__bullet'>
                    <ChevronDoubleRight
                      style={{
                        fontSize: '20px',
                        marginRight: '10px',
                        color: '#fff',
                      }}
                    />
                    -Participation in the Dao.
                    -Partecipation at the Contest.
                    -5 members of the whitelist will get a trip to a natural
                    place paid for by the team to explore the beauty of this
                    world.
                  </span>
                </p>
              </Col>
              <Col md={12} className='ut__box' style={{ height: '100%' }}>
                {' '}
                <h2 className='ut__h2'>Cleansing and Charity </h2>
                <p className='ut__p1'>
                  <span className='ut__bullet'>
                    <ChevronDoubleRight
                      style={{
                        fontSize: '20px',
                        marginRight: '10px',
                        color: '#fff',
                      }}
                    />{' '}
                    By participating in the DAO you will be able to choose,                       
                    together with the other members, which non-profit to give charity 
                    for environmental protection.
                  </span>
                  <span className='ut__bullet'>
                    <ChevronDoubleRight
                      style={{
                        fontSize: '20px',
                        marginRight: '10px',
                        color: '#fff',
                      }}
                    />{' '}
                    We will be doing charity for an Ocean Voyages Institute (and other institutes that you will choose) that
                    cleans the oceans from this plastic pollution.
                  </span>
                </p>
              </Col>
            </Row>
          </Col>
          <Col md={6} style={{ margin: '0px' }}>
            <div className='ut__box__right' style={{ height: '100%' }}>
              <h2 className='ut__h2'> Passive Income </h2>
              <p className='ut__p1'>
                <span className='ut__bullet'>
                  <ChevronDoubleRight
                    style={{
                      fontSize: '20px',
                      marginRight: '10px',
                      color: '#fff',
                    }}
                  />{' '}
                  Funding for initiatives involving exceptional materials and
                  novelties for environmental protection (similar to a startup
                  incubator). Nft holders will receive 20% of investment
                  revenue.
                </span>
                <span className='ut__bullet'>
                  <ChevronDoubleRight
                    style={{
                      fontSize: '20px',
                      marginRight: '10px',
                      color: '#fff',
                    }}
                  />{' '}                  
                  Free NFT of the next collection for the whitelist people.
                </span>
                <span className='ut__bullet'>
                  <ChevronDoubleRight
                    style={{
                      fontSize: '20px',
                      marginRight: '10px',
                      color: '#fff',
                    }}
                  />{' '}
                  50% of the revenue from the YouTube channel to the holders
                  (the other 50% to charity).
                </span>
                <span className='ut__bullet'>
                  <ChevronDoubleRight
                    style={{
                      fontSize: '20px',
                      marginRight: '10px',
                      color: '#fff',
                    }}
                  />{' '}
                  50% of the earnings from the sales of the hoodies and t-shirts
                  to the holders (the other 50% to charity).
                </span>
                <span className='ut__bullet'>
                  <ChevronDoubleRight
                    style={{
                      fontSize: '20px',
                      marginRight: '10px',
                      color: '#fff',
                    }}
                  />{' '}
                  20% of the revenue from the stores of items produced with
                  innovative recycled material will be redistributed to the
                  holders.
                </span>
              </p>
            </div>
          </Col>
        </Row>
        {/* <div style={{ margin: '10px 20px 0px 20px' }}>
        <Carousel
          ref={sliderRef}
          breakPoints={breakpoints}
          itemPadding={[10, 50]}
          scroll='Infinite'
        >
          {utItems.map((utItem, index) => (
            <div key={index} className='ut__box'>
              {utItem.icons}
              <h3 className='ut__h3'> {utItem.title}</h3>
              <p className='ut__p1'>{utItem.description}</p>
            </div>
          ))}
        </Carousel>
      </div>

      <div className='slider__arrows'>
        <button
          className='btn__slide__left'
          onClick={() => sliderRef.current.slidePrev()}
        >
          <ArrowLeft className='arrows__slider' />
        </button>

        <button
          className='btn__slide__left'
          onClick={() => sliderRef.current.slideNext()}
        >
          <ArrowRight className='arrows__slider' />
        </button>
      </div> */}
        <div>
          <Contest />
        </div>
        <img src={BG} className='ut__cats' alt='utility cats' width='50%' />
      </Container>
    </Container>
  );
};

export default Utilities;
